import * as Sentry from '@sentry/browser';
import { VITE_PRELOAD_RELOAD_KEY } from '../constants/vitePreload';

// Cooldown between auto-reloads so a persistent preload error can't trigger an infinite loop,
// while still allowing recovery from a later preload error in the same session.
export const VITE_PRELOAD_RELOAD_COOLDOWN_MS = 10_000;

type VitePreloadErrorEvent = Event & {
  payload: { message: string };
};

export const handleVitePreloadError = (event: VitePreloadErrorEvent): void => {
  event.preventDefault();
  const lastReloadAt = Number(sessionStorage.getItem(VITE_PRELOAD_RELOAD_KEY) ?? '0');
  const willReload = Date.now() - lastReloadAt > VITE_PRELOAD_RELOAD_COOLDOWN_MS;

  Sentry.captureMessage('vite:preloadError', {
    level: 'warning',
    extra: {
      originalError: event.payload.message,
      willReload,
    },
  });

  if (willReload) {
    sessionStorage.setItem(VITE_PRELOAD_RELOAD_KEY, String(Date.now()));
    window.location.reload();
  }
};

export const registerVitePreloadErrorHandler = (): void => {
  window.addEventListener('vite:preloadError', handleVitePreloadError as EventListener);
};
